import { KoButton, KoForm, KoLoader,  KoModal,  KoPagination, KoTable} from 'packages';
import React, {  useState } from 'react';
import styles from "./expenses.module.scss";
// import KoToolBar from 'shared/components/toolbar';
import { COLUMNS_GROUPS, ROW_ACTIONS } from "./constant";
import KoToolBar from 'shared/components/toolbar';
import KoIcon from '@kwapio/icons';
import RecordExpenseCurd from './recordExpenses';
import RecordMileageCurd from './recordMileage';

const Expenses = () => {
  const [isLoading] = useState(false);
  const [isModalRecordExpenses,setModalRecordExpenses]=useState(false);
  const [isModalRecordMileage,setModalRecordMileage]=useState(false);

  const [totalCount] = useState(0);
  const [form] = KoForm.useForm();

  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1
  });

  const OnRowSelection=(ticketId)=>{
    console.log("rowSelection");
  };

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page
    };
    const p = Object.assign(pagination, query);
    setPagination(p);
  };
  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader/>}
      <div className={`tableCard`}>
        <KoToolBar
          title={''}
          search={{ visible: true, onChange: () => { }, placeholder: 'Search by any parameter' }}
          filter={{
            visible: false,
            options: [{ label: 'Sort By Name', key: '0' },
              { label: 'Created At', key: '2' },
              { label: 'Sort By designation', key: '3' }]
          }}
          buttonList={[{
            label: 'Record Expense',
            type: 'primary',
            icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />, onClick: () => setModalRecordExpenses(true)
          },
          {
            label: 'Record Mileage',
            type: 'primary',
            icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />, onClick: () => setModalRecordMileage(true)
          }]}  />

        <KoTable data={{ columns: COLUMNS_GROUPS, rows:ROW_ACTIONS }}
          onRowSelection={OnRowSelection}/>
        <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`}
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
      </div>

      <KoModal
        title={`Add Record Mileage`}
        open={isModalRecordMileage}
        centered
        afterClose={() => { form.resetFields();  }}
        handleOk={() => { setModalRecordMileage(false); }}
        onClose={() => { setModalRecordMileage(false); form.resetFields(); }}
        width={'50vw'}
        maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setModalRecordMileage(false); form.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`Create`}
            onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <RecordMileageCurd/>
      </KoModal>

      <KoModal
        title={`Add Record Expenses`}
        open={isModalRecordExpenses}
        centered
        afterClose={() => { form.resetFields();  }}
        handleOk={() => { setModalRecordExpenses(false); }}
        onClose={() => { setModalRecordExpenses(false); form.resetFields(); }}
        width={'50vw'}
        maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setModalRecordExpenses(false); form.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`Create`}
            onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <RecordExpenseCurd/>
      </KoModal>
    </div>
  );
};

export default Expenses;